<template>
  <v-row>
    <v-col md="3" v-for="(row, index) in services" :key="index">
      <v-card flat>
        <v-img class="mx-auto ma-5" :src="row.icon" width="80"></v-img>

        <h2 class="text-center title">{{row.title}}</h2>
        <v-card-text class="font-weight-regular">{{row.description}}</v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

export default {
  name: "services",
  data: () => {
    return {
      services: [
        {
          title: "Development",
          icon: require("@/assets/landing/services/development.svg"),
          description:
            "Setiap bisnis memiliki permasalahan yang membutuhkan solusi berbeda. Kami membangun solusi yang bisa disesuaikan dengan kebutuhan."
        },
        {
          title: "Implementation",
          icon: require("@/assets/landing/services/implementation.svg"),
          description:
            "Perencanaan tahap awal sangat krusial, urutan eksekusi bisa menentukan keberhasilan implementasi."
        },
        {
          title: "Consulting",
          icon: require("@/assets/landing/services/consulting.svg"),
          description:
            "Analisa permasalahan dan tantangan yang dihadapi, mendesain solusi yang efektif, disertai data dan pengalaman dalam berbagai industri."
        },
        {
          title: "CLOUD Hosting",
          icon: require("@/assets/landing/services/cloud.svg"),
          description:
            "Tidak perlu investasi dengan nilai tinggi untuk server aplikasi atau infrastruktur jaringan. Aplikasi anda bahkan bisa terhubung meskipun berbeda kota."
        }
        
      ]
    };
  }
};
</script>